<script setup lang="ts">
defineExpose({
  name: "DeleteIcon",
});
</script>

<template>
  <svg
    class="DeleteIcon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1061_14"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" />
    </mask>
    <g mask="url(#mask0_1061_14)">
      <path
        d="M5.5 20.5V6H4.5V4.5H9V3.625H15V4.5H19.5V6H18.5V20.5H5.5ZM7 19H17V6H7V19ZM9.4 17H10.9V8H9.4V17ZM13.1 17H14.6V8H13.1V17Z"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.DeleteIcon {
  width: 100%;
  height: auto;
  fill: currentcolor;
}
</style>
